import { Suspense } from 'react';

import { EvaluationCriteriaGathering } from '@/module/Evaluation/components/EvaluationCriteriaGathering';
import { EvaluationCriteria } from '@/module/Evaluation/model/EvaluationTypes';

import { PendingSpinner } from '@/core/components';

import { Id } from '@feature/utils';

interface AuthorEvaluationWizardProps {
  evaluationId: Id;
  authorId: Id;
  template: EvaluationCriteria;
  isEvaluationClosed: boolean;
}

export function AuthorEvaluationWizard(props: AuthorEvaluationWizardProps) {
  const { evaluationId, template, authorId, isEvaluationClosed } = props;
  return (
    <Suspense fallback={<PendingSpinner h="300px" />}>
      <EvaluationCriteriaGathering
        criteria={template}
        evaluationId={evaluationId}
        authorId={authorId}
        isEvaluationClosed={isEvaluationClosed}
      />
    </Suspense>
  );
}
